import React from 'react';

import RACES from '../../data/races';
import STAR_SIGNS from '../../data/star_signs';

import { getTimeAgo } from '../../utils/helpers';
import { btnStyle } from '../../styles/theme';

function CharacterCard({ saved, onLoad, onDelete, onExport }) {
  const { character } = saved;
  const race = RACES.find(r => r.id === character.race);
  const starSign = STAR_SIGNS.find(s => s.id === character.starSign);

  // Calculate level estimate (total stats / 2 since stats cost 2 EXP each)
  const totalStats = Object.values(character.stats).reduce((a, b) => a + b, 0);
  const raceBaseStats = race ? Object.values(race.stats).reduce((a, b) => a + b, 0) : 0;
  const gainedStats = totalStats - raceBaseStats;
  const estimatedLevel = Math.floor(gainedStats / 2);

  const savedDate = new Date(saved.savedAt);
  const timeAgo = getTimeAgo(savedDate);

  return (
    <div style={{
      background: "rgba(20,16,10,0.6)",
      border: "1px solid rgba(201,168,76,0.2)",
      borderRadius: 8,
      padding: "16px",
      display: "grid",
      gridTemplateColumns: "1fr auto",
      gap: 16,
      alignItems: "center"
    }}>
      {/* Character Info */}
      <div>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8 }}>
          <div style={{ fontFamily: "'Cinzel', serif", fontSize: "18px", color: "#c9a84c" }}>
            {character.name}
          </div>
          <div style={{
            fontSize: "10px",
            color: "#8a7e5e",
            background: "rgba(201,168,76,0.1)",
            padding: "2px 8px",
            borderRadius: 12,
            border: "1px solid rgba(201,168,76,0.2)"
          }}>
            Lvl ~{estimatedLevel}
          </div>
        </div>
        <div style={{ fontSize: "13px", color: "#a08d4e", marginBottom: 6 }}>
          {race?.name} · {starSign?.name}
        </div>
        <div style={{ fontSize: "11px", color: "#6b6048" }}>
          💾 Saved {timeAgo}
        </div>
      </div>

      {/* Actions */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "flex-end" }}>
        <button onClick={() => onLoad(saved)} style={{ ...btnStyle("#16a085", "rgba(22,160,133,0.15)"), padding: "6px 12px", fontSize: "12px" }}>
          Load
        </button>
        <button onClick={() => onExport(saved)} style={{ ...btnStyle("#8e44ad", "rgba(142,68,173,0.15)"), padding: "6px 12px", fontSize: "12px" }}>
          Export
        </button>
        <button onClick={() => onDelete(saved.id)} style={{ ...btnStyle("#c0392b", "rgba(192,57,43,0.15)"), padding: "6px 12px", fontSize: "12px" }}>
          Delete
        </button>
      </div>
    </div>
  );
}

export default CharacterCard
